<template>
    <div class="user-settings">
        <div class="user-settings__card">
            <div class="user-settings__top"></div>

            <div class="user-settings__unum">
                {{userData.unum}}
            </div>

            <form class="user-settings__form" autocomplete="off">
                <div class="user-settings__row">
                    <text-field v-model="form.firstName"
                                label="Vorname"
                    />
                </div>

                <div class="user-settings__row">
                    <text-field v-model="form.lastName"
                                label="Nachname"
                    />
                </div>

                <div class="user-settings__row">
                    <text-field v-model="form.email"
                                label="E-Mail"
                    />
                </div>

                <div class="user-settings__row">
                    <select id="inputStao" v-model="form.stao">
                        <option v-for="option in staos"
                                :key="option.id"
                                :value="option.id"
                                class="settingsInput"
                        >
                            {{option.name}}
                        </option>
                    </select>
                </div>

                <div class="user-settings__row">
                    <text-field v-model="form.newPassword"
                                type="password"
                                label="Passwort"
                    />
                </div>

                <div class="passwordinfo">{{pwinfo}}</div>

                <div class="passwordtime">{{pwtime}}</div>

                <div class="user-settings__row">
                    <text-field v-model="form.newPasswordRepeated"
                                type="password"
                                label="Passwort (wiederholt)"
                    />
                </div>

                <div class="user-settings__row">
                    <default-button @click.prevent="save"
                                    :variations="['full-width']"
                    >
                        Speichern
                    </default-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import zxcvbn from 'zxcvbn';
import TextField from '../common/text-field';
import DefaultButton from '../common/default-button';

export default {
    components: { DefaultButton, TextField },
    data() {
        return {
            form: {
                firstName: '',
                lastName: '',
                email: '',
                stao: '',
                newPassword: '',
                newPasswordRepeated: ''
            },
            pwinfo: '',
            pwscore: 5,
            pwtime: ''
        }
    },
    computed: {
        userData() {
            return this.$store.getters['user/userData'];
        },
        staos() {
            return this.$store.getters['user/staos'];
        }
    },
    methods: {
        save() {
            if (this.pwscore >= 1) {
                this.$store.dispatch('user/saveNewUserData', {
                    new: {
                        unum: this.userData.unum,
                        fname: this.form.firstName,
                        lname: this.form.lastName,
                        email: this.form.email,
                        stao: this.form.stao,
                        autlev: this.userData.autlev,
                        lagerCheff: this.userData.lagerCheff,
                        pw: this.form.newPassword,
                        rpw: this.form.newPasswordRepeated
                    },
                    old: this.userData
                });
            } else {
                this.$store.dispatch('notifications/notification', {
                    msg: 'Passwort nicht sicher genug',
                    error: true,
                    time: 2000
                });
            }
        }
    },
    watch: {
        'form.newPassword': function() {
            if (this.form.newPassword !== '') {
                const test = zxcvbn(this.form.newPassword);

                this.pwscore = test.score;
                this.pwtime = 'Zeit um zu cracken: ' + test.crack_times_display.offline_slow_hashing_1e4_per_second;

                if (test.score <= 1) {
                    this.pwinfo = 'Passwort nicht sicher genug';
                } else if (test.score > 1 && test.score <= 3) {
                    this.pwinfo = 'Passwort immer noch nicht ganz sicher, aber mach nur.'
                } else {
                    this.pwinfo = '';
                }
            } else {
                this.pwinfo = '';
                this.pwscore = 5;
                this.pwtime = '';
            }
        }
    },
    created() {
        this.$store.dispatch('user/getUserData');
        this.$store.dispatch('user/getStaos');

        Object.assign(this.form, {
            firstName: this.userData.fname,
            lastName: this.userData.lname,
            email: this.userData.email,
            stao: this.userData.stao
        });
    }
}
</script>

<style scoped lang="scss">
    .user-settings {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: $color-white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .user-settings__card {
        width: 100%;
        height: 100vh;
    }

    .user-settings__top {
        height: 5rem;
    }

    .user-settings__unum {
        position: relative;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 3rem;
        background-color: $color-gray;
        color: $color-white;
        margin-bottom: 1.25rem;
    }

    .user-settings__form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .user-settings__row {
        margin-bottom: 1rem;
    }

    #inputStao {
        font-size: 1rem;
    }

    .settingsInput {
        font-size: 1rem;
    }

    .passwordinfo {
        font-size: 1rem;
        color: $color-red;
        padding: 0.375rem;
    }

    .passwordtime {
        font-size: 1rem;
        padding: 0.375rem;
    }

    @include medium {
        .user-settings__top {
            display: none;
        }

        .user-settings__card {
            width: 31rem;
            @include default-shadow;
        }
    }

    @include extra-large {
        .user-settings__card {
            width: 31rem;
            @include default-shadow;
            height: 80vh;
        }
    }

</style>
